import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.permisoVista('mantenimiento-inspecciones','r'))?_c(VCol,{attrs:{"cols":"12"}},[_c(VDataTable,{attrs:{"headers":_vm.headers,"items":_vm.inspecciones,"loading":_vm.loading,"loading-text":"Cargando... Espere, Por Favor.","footer-props":{
			disableItemsPerPage: true,
			disablePagination: this.loading,
		},"disable-sort":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }